import CustomTitle from './CustomTitle';

export default CustomTitle;
